import { emptyElement } from "../components/Section/sectionConst";
import { IListConfing } from "../definitionsNew/configs";
import { t } from "../helpers/userHelper";
import { dictionary } from "../untils/dictionary";
import { IBaseType } from "./element";
import { fields } from "../definitionsNew/fields";
import { pl } from "date-fns/locale";
import { format } from "date-fns";
import { getFillElementsScopes } from "../definitionsNew/setFieldsHelper";
import { IProjectDetailsObj } from "../store/interface/projectDetails";
import { IProject } from "../store/interface/projects";

export interface IJointType extends IBaseType {
  [key: string]: string | number | undefined | boolean;
}

export const getJointDefinition = (
  config: IListConfing[],
  data?: IJointType
): IJointType => {
  const jointObj: IJointType = {
    ...emptyElement,
  };
  jointObj.type = data?.type || "joint";

  Object.keys(emptyElement).forEach((key) => {
    if (data && data[key] !== undefined) {
      jointObj[key] = data[key];
    }
  });

  config.forEach((_configField) => {
    if (data && data[_configField.id] !== undefined) {
      jointObj[_configField.id] = data[_configField.id];
    } else {
      const def = fields.find((_item) => _item.id === _configField.id);
      jointObj[_configField.id] = def!.type === "string" ? "" : undefined;
    }
  });

  return jointObj;
};

export const getJointDetails = (
  state: IJointType,
  config: IListConfing[],
  projectDetails: IProjectDetailsObj,
  projects: IProject[],
  sectionID?: string
) => {
  const jointObj: any = [];

  config.forEach((_configField) => {
    const def = fields.find((_item) => _item.id === _configField.id);
    let value: string = "";
    switch (def!.formType) {
      case "fill":
        const options = getFillElementsScopes(
          def!.name,
          def!.sourceFiled as string,
          def!.sourceScope as string,
          projectDetails,
          projects,
          sectionID
        );
        if (options && state[_configField.id]) {
          const option = options.find(
            (opt) => opt.value === state[_configField.id]
          );
          value = option ? (option.label as string) : "";
        }
        break;
      case "select":
        if (def?.options && state[_configField.id]) {
          const option = def.options.find(
            (opt) => opt.value === state[_configField.id]
          );
          value = option ? (option.label as string) : "";
        }

        break;
      case "date":
        if (state[_configField.id]) {
          value = format(state[_configField.id] as number, "dd-MM-yyyy");
        }
        break;
      default:
        value = state[_configField.id] as string;
        break;
    }
    jointObj.push({
      label: t(dictionary[_configField.id as keyof typeof dictionary]),
      value: value,
      type: "text",
    });
  });
  return jointObj;
};
export const jointValidatorFileds: string[] = ["joint_name"];
